"use client";

import { createSavedSearch, type CreateSavedSearchResult } from "@/actions/save-search";
import { Button } from "@/components/ui/button";
import { BookmarkPlus } from "lucide-react";
import { useRouter, useSearchParams } from "next/navigation";
import { useTransition } from "react";
import { toast } from "sonner";
interface SaveSearchButtonProps {
  className?: string;
}
const QUOTA_REDIRECT_DELAY_MS = 1500;
export function SaveSearchButton({
  className
}: SaveSearchButtonProps) {
  const searchParams = useSearchParams();
  const router = useRouter();
  const [isPending, startTransition] = useTransition();
  const label = "Guardar búsqueda";
  const handleClick = () => {
    const params: Record<string, string[]> = {};
    searchParams.forEach((value, key) => {
      params[key] ??= [];
      params[key].push(value);
    });
    startTransition(() => {
      createSavedSearch(params).then((res: CreateSavedSearchResult) => {
        if (res.errors.search) {
          if (res.quotaExceeded) {
            toast.error("Has excedido la cuota de tu plan", {
              description: `${res.errors.search} Te llevamos a los planes…`
            });
            setTimeout(() => router.push("/pricing"), QUOTA_REDIRECT_DELAY_MS);
          } else {
            toast.error("Error al guardar la búsqueda", {
              description: res.errors.search
            });
          }
        } else if (res.values.search) {
          toast.success(res.values.search);
        }
        return undefined;
      }).catch(() => {
        toast.error("Error al guardar la búsqueda", {
          description: "Ha ocurrido un error al guardar la búsqueda. Por favor, inténtelo de nuevo en unos minutos."
        });
        return undefined;
      });
    });
  };
  return <Button className={className ?? "h-12"} variant="outline" aria-label={label} type="button" disabled={isPending} onClick={handleClick}>
      <BookmarkPlus className="size-4" />
      <span className="ml-1 hidden sm:inline">{label}</span>
      <span className="sr-only">{label}</span>
    </Button>;
}